<!--<div>-->

  <div class="hourCell" [ngStyle]="workedHoursValidation.style()" (click)="enterEditMode()">


    <ng-template #workedHours>
      <ng-template [ngIf]="!workedHoursValidation.isSuccess()"><div style="padding:0px 10px 5px 10px;">
        <div *ngFor="let msg of workedHoursValidation.messages">
          {{msg}}
        </div>
      </div></ng-template>
    </ng-template>

    <ng-template [ngIf]="hasErrors()"><div style="float:right;"  placement="top" [ngbPopover]='workedHours' triggers="mouseenter:mouseleave">
      <i class="fa fa-exclamation-triangle"></i>
    </div></ng-template>

    <ng-template [ngIf]="!editMode"><div class="zoomable">
      <ng-template [ngIf]="needToSpecifyHours()"><div class="hourCell-main">
        {{currentEmployeeHoraire.tsStartDt | myDateFormat:'LT':'xx:xx'}}-{{currentEmployeeHoraire.tsEndDt | myDateFormat:'LT':'xx:xx'}}
      </div></ng-template>

      <ng-template [ngIf]="hasInfo() && needToSpecifyHours()"><div class="hourCell-bottom">
        <ng-template [ngIf]="hasScheduledInfo() || hasPunchedInfo()"><div class="hourCell-bottom-left">
          {{currentEmployeeHoraire.sdStartDt | myDateFormat:'LT':'xx:xx'}}-{{currentEmployeeHoraire.sdEndDt | myDateFormat:'LT':'xx:xx'}}
        </div></ng-template>

        <ng-template [ngIf]="hasPunchedInfo() && needToSpecifyHours()"><div class="hourCell-bottom-right">
          {{currentEmployeeHoraire.tsStartPunchDt | myDateFormat:'LT':'xx:xx'}}-{{currentEmployeeHoraire.tsEndPunchDt | myDateFormat:'LT':'xx:xx'}}
        </div></ng-template>
      </div></ng-template>
    </div></ng-template>


    <ng-template [ngIf]="editMode"><div style="width: 400px;height:250px; z:10; background-color: blue;">
      <ng-template [ngIf]="needToSpecifyHours()"><div class="hourCell-main">
        <div class="col" >
          <div class="form-group">
            <label>{{'AccountedShiftStart' | translate}}</label>
            <input type="text" name="realShiftStartText"  class="form-control" [textMask]="{mask: hourMinuteMask}" [(ngModel)]="realShiftStartText" (change)="onChange($event)">
          </div>
        </div>
        <div class="col" >
          <div class="form-group">
            <label>{{'AccountedShiftEnd' | translate}}</label>
            <input type="text" name="realShiftEndText"  class="form-control" [textMask]="{mask: hourMinuteMask}" [(ngModel)]="realShiftEndText" (change)="onChange($event)">
          </div>
        </div>
       <!--{{currentEmployeeHoraire.tsStartDt | myDateFormat:'LT':'xx:xx'}}-{{currentEmployeeHoraire.tsEndDt | myDateFormat:'LT':'xx:xx'}}-->
      </div></ng-template>
    </div></ng-template>


  </div>
